<template>
  <div class="addMaterials">
    <el-form ref="baseForm" class="baseForm" :model="form" :rules="rules" label-width="140px">
      <el-form-item label="考生状态：" prop="state">
        <el-select v-model="form.state" clearable>
          <el-option label="未安排" :value="1"></el-option>
          <el-option label="已考生" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道：" prop="channel">
        <el-input v-model="form.channel" placeholder="渠道名称"></el-input>
      </el-form-item>
      <el-form-item label="业务员：" prop="salesman">
        <el-input v-model="form.salesman" placeholder="业务员"></el-input>
      </el-form-item>
      <el-form-item label="选择证书和等级：" prop="jobList">
        <el-cascader
          v-model="form.jobList"
          placeholder="请选择证书/等级"
          :options="jobLevelList"
          :props="{
            value: 'id',
            label: 'jobName',
            children: 'levelList',
          }"
          @change="handleJobLevelChange"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="手机号：" prop="phone">
        <el-input v-model="form.phone" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item label="真实姓名：" prop="name">
        <el-input v-model="form.name" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号：" prop="idCard">
        <el-input v-model="form.idCard" placeholder="身份证号" :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item label="报考时间：" prop="applicationTime">
        <el-date-picker
          v-model="form.applicationTime"
          type="date"
          placeholder="报考时间"
          style="width: 100%;"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="证件照片：" prop="idCardFront">
        <div class="imageUpload">
          <div class="imageFront">
            <el-upload
              ref="upload"
              action="/api/third/api/tencentUpload/upload/file/local"
              accept=".jpg,.jpeg,.png,.gif,.svg,.JPG,.JPEG"
              :show-file-list="false"
              :multiple="true"
              :on-success="handlePhotoFrontSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.idCardFront" :src="form.idCardFront" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">正面</div>
            </el-upload>
          </div>
          <div class="imageBack">
            <el-upload
              ref="upload"
              action="/api/third/api/tencentUpload/upload/file/local"
              accept=".jpg,.jpeg,.png,.gif,.svg,.JPG,.JPEG"
              :show-file-list="false"
              :multiple="true"
              :on-success="handlePhotoBackSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.idCardBack" :src="form.idCardBack" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">背面</div>
            </el-upload>
          </div>
        </div>
        <div class="tip">大小20MB，支持jpg、png、jpeg</div>
      </el-form-item>
      <el-form-item label="登记照：" prop="registration">
        <div class="registrationPhoto">
          <el-upload
            ref="upload"
            action="/api/third/api/tencentUpload/upload/file/local"
            accept=".jpg,.jpeg,.png,.gif,.svg,.JPG,.JPEG"
            :show-file-list="false"
            :multiple="true"
            :on-success="handleRegistrationPhotoSuccess"
            :before-upload="beforeAvatarUpload1"
          >
            <img v-if="form.registration" :src="form.registration" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
              1寸彩色免冠照片，大小10MB内，支持jpg、png、jpeg，最多可上传1张
            </div>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="最高学历：" prop="educationLevel">
        <el-select v-model="form.educationLevel" clearable>
          <el-option
            v-for="(item, index) in educationList"
            :key="index"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.educationLevel" label="毕业证书照片：" prop="graduationCertificate">
        <div class="registrationPhoto">
          <el-upload
            ref="upload"
            action="/api/third/api/tencentUpload/upload/file/local"
            accept=".jpg,.jpeg,.png,.gif,.svg,.JPG,.JPEG"
            :show-file-list="false"
            :multiple="true"
            :on-success="handleDiplomaPhotoSuccess"
            :before-upload="beforeAvatarUpload2"
          >
            <img
              v-if="form.graduationCertificate"
              :src="form.graduationCertificate"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
              大小5MB，支持.png.jpg.jpeg，最多可上传1张
            </div>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item v-if="form.educationLevel" label="毕业证书编号：" prop="certificateNo">
        <el-input v-model="form.certificateNo" placeholder="请输入毕业证上的编号"></el-input>
      </el-form-item>
      <el-form-item v-if="form.educationLevel" label="毕业专业：" prop="major">
        <!-- <el-input v-model="form.major" placeholder="请输入毕业证上描述的专业"></el-input> -->
        <el-autocomplete
          v-model="form.major"
          :fetch-suggestions="querySearch"
          placeholder="请输入毕业证上描述的专业"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="所在单位：" prop="company">
        <el-input v-model="form.company" placeholder="请输入目前所在单位名称"></el-input>
      </el-form-item>
      <el-form-item v-if="form.educationLevel" label="工作证明：" prop="workCertificateList">
        <div class="workUpload">
          <el-upload
            action="/api/third/api/tencentUpload/upload/file/local"
            accept=".docx,.doc,.pdf,.jpg,.png"
            :limit="1"
            :on-preview="handleDownLoad"
            :on-remove="handleWorkCertificateRemove"
            :on-success="handleBeforeWorkCertificateFileUpload"
            :file-list="form.workCertificateList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <template v-slot:tip>
              <div class="explain">
                文件大小限制10MB，支持.docx.doc，最多可上传1个
              </div>
            </template>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="参保证明：" prop="insuranceCertificateList">
        <div class="workUpload">
          <el-upload
            action="/api/third/api/tencentUpload/upload/file/local"
            accept=".docx,.doc,.pdf,.jpg,.png"
            :limit="1"
            :on-preview="handleDownLoad"
            :on-remove="handleProofListRemove"
            :on-success="handleProofListFileUpload"
            :file-list="form.insuranceCertificateList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <template v-slot:tip>
              <div class="explain">
                文件大小限制10MB，支持.docx.doc，最多可上传1个
              </div>
            </template>
          </el-upload>
          <div class="downLoadCard">
            <span class="download-text" @click="downloadTemp('湖北（支付宝）参保证明下载流程')"
              >湖北(支付宝)参保证明下载流程说明.pdf</span
            >
            <span class="download-text" @click="downloadTemp('湖北（政务服务网）参保下载流程')"
              >湖北(政务服务网)参保下载流程.pdf</span
            >
            <span
              class="download-text"
              @click="downloadTemp('湖北（支付宝）参保证明下载流程（无电子社保卡版）')"
              >湖北（支付宝）参保证明下载流程（无电子社保卡版）.pdf</span
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item label="附件：" prop="appendixList">
        <div class="workUpload">
          <el-upload
            action="/api/third/api/tencentUpload/upload/file/local"
            accept=".docx,.doc,.pdf"
            :limit="10"
            :on-preview="handleDownLoad"
            :on-remove="handleAttachmentListRemove"
            :on-success="handleAttachmentListFileUpload"
            :file-list="form.appendixList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <template v-slot:tip>
              <div class="explain">
                文件大小限制10MB，支持.docx.doc，最多可上传10个
              </div>
            </template>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="checkBtn" @click="handleSubmitFn">{{
          id ? '编辑' : '添加'
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { filterJobLevel } from '@/api/exam'
import to from 'await-to'
import {
  applyInfoAdd,
  applyEducationFilter,
  applyInfoQuery,
  applyInfoEdit,
  certificateMajor,
  workJudge,
} from '@/api/apply'
export default {
  data() {
    return {
      id: this.$route.query.id || '',
      form: {
        state: '',
        channel: '',
        salesman: '',
        jobList: [],
        phone: '',
        name: '',
        idCard: '',
        applicationTime: '',
        idCardFront: '',
        idCardBack: '',
        registration: '',
        educationLevel: '',
        graduationCertificate: '',
        certificateNo: '',
        major: '',
        company: '',
        workCertificateList: [],
        workCertificate: '',
        insuranceCertificateList: [],
        insuranceCertificate: '',
        appendixList: [],
      },
      rules: {
        state: [{ required: true, message: '请选择考生状态', trigger: 'change' }],
        channel: [{ required: true, message: '请输入渠道', trigger: 'blur' }],
        salesman: [{ required: true, message: '请输入业务员', trigger: 'blur' }],
        jobList: [{ required: true, message: '请选择证书/等级', trigger: 'change' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        applicationTime: [{ required: true, message: '请选择报考时间', trigger: 'blur' }],
        idCardFront: [{ required: true, message: '请上传证件照片', trigger: 'blur' }],
        idCardBack: [{ required: true, message: '请上传证件照片', trigger: 'blur' }],
        registration: [{ required: true, message: '请上传登记照片', trigger: 'blur' }],
        educationLevel: [{ required: true, message: '请选择最高学历', trigger: 'change' }],
        // graduationCertificate: [{ required: true, message: '请上传毕业证书照片', trigger: 'blur' }],
        // certificateNo: [{ required: true, message: '请输入毕业证书编号', trigger: 'blur' }],
        // major: [{ required: true, message: '请输入毕业专业', trigger: 'blur' }],
        company: [{ required: true, message: '请输入所在单位', trigger: 'blur' }],
        // workCertificateList: {
        //   required: true,
        //   type: 'array',
        //   message: '请上传工作证明',
        //   validator: (rule, value, callback) => {
        //     value = this.form.workCertificateList
        //     if (!value || value.length == 0) {
        //       return callback(new Error('请上传工作证明'))
        //     } else {
        //       return callback()
        //     }
        //   },
        // },
      },
      jobLevelList: [],
      educationList: [],
      majorList: [],
    }
  },
  mounted() {
    this.getJobLevelList()
    this.handleGetFilterEducation()
    if (this.id) {
      this.handleGetMaterialsQuery()
    }
  },
  methods: {
    async handleDownLoad(file) {
      const response = await fetch(file.url)
      const blob = await response.blob()
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = file.name
      a.click()
      window.URL.revokeObjectURL(url)
    },
    querySearch(queryString, cb) {
      var majorList = this.majorList
      var results = queryString ? majorList.filter(this.createFilter(queryString)) : majorList
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return majorList => {
        return majorList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    downloadTemp(name) {
      const href = `/${name}.pdf`
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = href
      a.download = name
      a.click()
      URL.revokeObjectURL(a.href)
    },
    async handleGetMajorList(id) {
      const [res, err] = await to(certificateMajor({ jobId: id }))
      if (err) return this.$message.warning(err.msg)
      // this.majorList = res.data
      res.data.forEach(item => {
        let obj = {
          value: item,
        }
        this.majorList.push(obj)
      })
    },
    async handleGetMaterialsQuery() {
      const [res, err] = await to(applyInfoQuery({ id: this.id }))
      if (err) return this.$message.warning(err.msg)
      this.form = res.data
      if (res.data.workCertificate) {
        this.form.workCertificateList = [{ name: '工作证明', url: res.data.workCertificate }]
      } else {
        this.form.workCertificateList = []
      }
      if (res.data.insuranceCertificate) {
        this.form.insuranceCertificateList = [
          { name: '参保证明', url: res.data.insuranceCertificate },
        ]
      } else {
        this.form.insuranceCertificateList = []
      }
      if (res.data.appendixList && res.data.appendixList.length > 0) {
        this.form.appendixList.forEach(element => {
          element.name = element.fileName
          element.url = element.fileUrl
        })
      }
      this.handleGetMajorList(res.data.jobId)
    },
    handleSubmitFn() {
      if (this.id) {
        this.handleEditMaterial()
      } else if (!this.id) {
        this.handleAddMaterial()
      }
    },
    handleEditMaterial() {
      this.$refs['baseForm'].validate(async valid => {
        if (!valid) return
        if (this.form.educationLevel == 1 || this.form.educationLevel == 2) {
          if (this.form.workCertificateList.length == 0)
            return this.$message.warning('请上传工作证明！')
          this.editFn()
        } else {
          if (!this.form.graduationCertificate) return this.$message.warning('请上传毕业证书照片')
          if (!this.form.certificateNo) return this.$message.warning('请输入毕业证书编号')
          if (!this.form.major) return this.$message.warning('请输入毕业专业')
          const [res, err] = await to(workJudge({ jobId: this.form.jobId, major: this.form.major }))
          if (err) return this.$message.warning(err.msg)
          console.log(`output->this.form.workCertificateList`, this.form.workCertificateList)
          if (res.data && this.form.workCertificateList.length == 0)
            return this.$message.warning('请输入工作证明')
          this.editFn()
        }
      })
    },
    async editFn() {
      if (this.form.workCertificateList.length > 0) {
        this.form.workCertificate = this.form.workCertificateList[0].url
      }
      if (this.form.insuranceCertificateList.length > 0) {
        this.form.insuranceCertificate = this.form.insuranceCertificateList[0].url
      } else if (this.form.insuranceCertificateList.length == 0) {
        this.form.insuranceCertificate = ''
      }
      const [, err] = await to(applyInfoEdit({ ...this.form }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('编辑成功')
    },
    handleAddMaterial() {
      this.$refs['baseForm'].validate(async valid => {
        if (!valid) return
        if (this.form.educationLevel == 1 || this.form.educationLevel == 2) {
          if (this.form.workCertificateList.length == 0)
            return this.$message.warning('请上传工作证明！')
          this.addFn()
        } else {
          if (!this.form.graduationCertificate) return this.$message.warning('请上传毕业证书照片')
          if (!this.form.certificateNo) return this.$message.warning('请输入毕业证书编号')
          if (!this.form.major) return this.$message.warning('请输入毕业专业')
          const [res, err] = await to(workJudge({ jobId: this.form.jobId, major: this.form.major }))
          if (err) return this.$message.warning(err.msg)
          if (res.data && this.form.workCertificateList.length == 0)
            return this.$message.warning('请输入工作证明')
          this.addFn()
        }
      })
    },
    async addFn() {
      if (this.form.workCertificateList.length > 0) {
        this.form.workCertificate = this.form.workCertificateList[0].url
      }
      if (this.form.insuranceCertificateList.length > 0) {
        this.form.insuranceCertificate = this.form.insuranceCertificateList[0].url
      } else if (this.form.insuranceCertificateList.length == 0) {
        this.form.insuranceCertificate = ''
      }
      const [, err] = await to(applyInfoAdd({ ...this.form }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('添加成功')
    },
    async handleGetFilterEducation() {
      const [res, err] = await to(applyEducationFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.educationList = res.data
    },
    async getJobLevelList() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.jobLevelList = res.data
    },
    handleJobLevelChange() {
      if (this.form.jobList.length > 0) {
        this.form.jobId = this.form.jobList[0]
        this.form.jobLevel = this.form.jobList[1]
        this.handleGetMajorList(this.form.jobId)
      }
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes('image')
      if (!isImage) {
        this.$message.error('上传文件类型必须是图片!')
      }
      const isLt5M = file.size / 1024 / 1024 < 20
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isImage && isLt5M
    },
    beforeAvatarUpload1(file) {
      const isImage = file.type.includes('image')
      if (!isImage) {
        this.$message.error('上传文件类型必须是图片!')
      }
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return isImage && isLt5M
    },
    beforeAvatarUpload2(file) {
      const isImage = file.type.includes('image')
      if (!isImage) {
        this.$message.error('上传文件类型必须是图片!')
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isImage && isLt5M
    },
    //证件照正面
    async handlePhotoFrontSuccess(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.idCardFront = response.data
    },
    //证件照背面
    async handlePhotoBackSuccess(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.idCardBack = response.data
    },
    //登记照
    async handleRegistrationPhotoSuccess(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.registration = response.data
    },
    //毕业证书照片
    async handleDiplomaPhotoSuccess(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.graduationCertificate = response.data
    },
    //工作证明
    handleBeforeWorkCertificateFileUpload(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.workCertificateList = []
      this.form.workCertificateList.push({
        name: fileList.name,
        url: response.data,
      })
    },
    handleWorkCertificateRemove(file, fileList) {
      this.form.workCertificateList = fileList
    },
    //参保证明
    handleProofListFileUpload(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.form.insuranceCertificateList = []
      this.form.insuranceCertificateList.push({
        name: fileList.name,
        url: response.data,
      })
    },
    handleProofListRemove(file, fileList) {
      this.form.insuranceCertificateList = fileList
    },
    //附件
    handleAttachmentListFileUpload(response, fileList) {
      this.form.appendixList.push({
        name: fileList.name,
        url: response.data,
        fileName: fileList.name,
        fileUrl: response.data,
      })
    },
    handleAttachmentListRemove(file, fileList) {
      this.form.appendixList = fileList
    },
  },
}
</script>
<style lang="scss" scoped>
.addMaterials {
  padding: 20px;
  height: 100%;
  /deep/.baseForm {
    padding-bottom: 50px !important;
    .el-input,
    .el-textarea,
    .el-date-editor {
      width: 440px !important;
      .el-input__inner,
      .el-textarea__inner {
        border-radius: 2px;
      }
      input {
        height: 40px;
      }
    }
    .imageUpload {
      display: flex;
      .imageFront {
        margin-right: 30px;
      }
      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        position: relative;
        width: 148px;
        height: 98px;
        img {
          @extend %width-height;
        }
        .avatar-uploader-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -15px;
          margin-left: -15px;
          font-size: 28px;
          color: #8c939d;
        }
        &:hover {
          border-color: #3671bf;
        }
      }
      .el-upload__tip {
        margin-top: 0;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
      }
    }
    .registrationPhoto {
      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        position: relative;
        width: 148px;
        height: 148px;
        img {
          @extend %width-height;
        }
        .avatar-uploader-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -15px;
          margin-left: -15px;
          font-size: 28px;
          color: #8c939d;
        }
        &:hover {
          border-color: #3671bf;
        }
      }
      .el-upload__tip {
        margin-top: 0;
        font-size: 14px;
        line-height: 16px;
      }
    }
    .workUpload {
      .el-upload-list__item {
        width: 500px !important;
      }
      .downLoadCard {
        margin-top: 10px;
        span {
          display: block;
        }
        .download-text {
          line-height: 14px;
          cursor: pointer;
          margin-bottom: 10px;
          color: #1890ff;
        }
      }
    }
    .checkBtn {
      margin-top: 50px;
      width: 350px;
      height: 40px;
    }
  }
}
</style>
